// Reads every page of a paged list endpoint, so a picker never stops at a fixed limit.
// pick(responseBody) returns { items, total, totalPages } for one page.
// Rows are deduped by _id (a row added while paging can shift the next page by one).
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../helpers';

// Loop guard only (a server that never reports a total and always returns a full page).
const MAX_PAGES = 1000;

export const fetchAllPages = async (path, params, pick, pageSize = 100) => {
  const seen = new Set();
  const out = [];
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const res = await axios.get(`${config.api.base_url}${path}`, {
      params: { ...(params || {}), page, limit: pageSize },
      headers: { Authorization: 'Bearer ' + getUserToken() },
    });
    const { items, total, totalPages } = pick(res.data) || {};
    const rows = Array.isArray(items) ? items : [];
    rows.forEach((row) => {
      const key = row && row._id != null ? String(row._id) : null;
      if (key && seen.has(key)) return;
      if (key) seen.add(key);
      out.push(row);
    });
    if (rows.length < pageSize) break;
    if (totalPages != null && page >= Number(totalPages)) break;
    if (total != null && out.length >= Number(total)) break;
  }
  return out;
};
